var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForbidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12,2.608C6.816,2.608,2.614,6.811,2.614,11.994s4.202,9.386,9.386,9.386,9.386-4.202,9.386-9.386S17.184,2.608,12,2.608Zm6.098,9.386c0,1.146-.322,2.214-.871,3.13L8.87,6.767c.916-.55,1.984-.871,3.13-.871,3.368,0,6.098,2.73,6.098,6.098Zm-12.196,0c0-1.143.32-2.208.867-3.122l8.354,8.354c-.914.547-1.98.867-3.122.867-3.368,0-6.098-2.73-6.098-6.098Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden);
export default __webpack_public_path__ + "static/media/forbidden.f235350e513927f7a221abf43f00b99d.svg";
export { ForwardRef as ReactComponent };